import { AppointmentModel } from '@devexpress/dx-react-scheduler';
import { daysInWeek } from 'helpers/timeConsts';

interface CheckIsAnyScheduleInRangeParams {
  workSchedules: AppointmentModel[];
  regular: boolean;
  dayWithWeekOffset: number;
}

export default function checkIsAnyScheduleInRange({
  dayWithWeekOffset,
  regular,
  workSchedules,
}: CheckIsAnyScheduleInRangeParams) {
  if (!regular) {
    return workSchedules.some(
      (workSchedule) => workSchedule.day === dayWithWeekOffset,
    );
  }

  return workSchedules.some(
    (workSchedule) => workSchedule.day >= dayWithWeekOffset + 1 - daysInWeek,
  );
}
